import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  tableContainer: {
    width: "100%",
  },
  table: {
    width: "100%",
  },
  tableHeader: {
    background: theme.palette.primary.main,
    width: "100%",
    display: "table",
    tableLayout: "fixed",
  },
  tableRow: {
    borderCollapse: "collapse",
  },
  tableBody: {
    display: "block",
    overflowY: "auto",
    [theme.breakpoints.down(823)]: {
      height: `calc(100vh - 305px)`,
    },
  },
  assetVersionTablecell: {
    padding: "1.3% 0% !important",
    color: theme.palette.text.tertiary,
    // borderCollapse: "collapse",
    background: theme.palette.primary.main,
    width: "16%",
    borderBottom: `1px solid ${theme.palette.text.tertiary}`,
  },
  assetVersionTablecellTwo: {
    padding: "1.3% 0% !important",
    color: theme.palette.text.tertiary,
    // borderCollapse: "collapse",
    background: theme.palette.primary.main,
    width: "10%",
    borderBottom: `1px solid ${theme.palette.text.tertiary}`,
  },
  assetVersionTablecellThree: {
    padding: "1.3% 1% 1.3% 0% !important",
    color: theme.palette.text.tertiary,
    // borderCollapse: "collapse",
    background: theme.palette.primary.main,
    width: "10%",
    borderBottom: `1px solid ${theme.palette.text.tertiary}`,
  }
}));

export default useStyles;
